export const specsInfo = {
  engine_displacement: "The total engine size of vehicle, which is measured in cc.",
  motor_power: "The motor’s continuous power during everyday driving.",
  motor_type: "Type of electric motor used to drive the vehicle.",
  max_power: "The highest power the engine or motor can produce.",
  max_torque: "The maximum pulling force available for acceleration.",
  transmission_type: "The system that transfers power from engine or motor to the wheels.",
  gearbox: "The set of gears that control speed and power delivery.",
  no_of_cylinders: "The number of engine cylinders where fuel burns to produce power.",
  ground_clearance_unladen: "Distance between the ground and the vehicle’s underside when empty.",
  ground_clearance_laden: "Ground clearance when the vehicle is fully loaded.",

  arai_mileage: "Fuel efficiency tested under standard government conditions.",
  fuel_type: "The kind of fuel or energy source the vehicle uses.",
  city_mileage: "Expected fuel efficiency in stop-and-go city traffic.",
  wltp_mileage: "Mileage tested under global WLTP standards for realistic conditions.",
  body_type: "The vehicle shape category",
  battery_capacity: "The amount of energy stored in the battery, measured in kWh.",
  battery_warranty: "Manufacturer coverage period for battery health and defects.",
  battery_type: "The kind of battery technology used in the vehicle.",
  range: "Distance the vehicle can travel on a full charge or tank.",
  charging_time_ac: "Time taken to charge using a regular AC charger.",
  charging_time_dc: "Time taken using a fast DC charger.",
  charging_time_15a: "Charging time using a standard home 15A socket.",
  charging_port: "Location and type of plug used for charging.",
  charging_options: "Available methods to recharge the battery.",
  charger_type: "The specific charger supplied or supported by the vehicle.",
  regenerative_braking: "System that recovers energy during braking to recharge the battery.",
  regenerative_braking_levels: "Adjustable strength of regenerative braking.",
  charging_time: "Total time needed to fully charge the battery.",

  front_suspension: "Suspension setup that absorbs bumps at the front wheels.",
  rear_suspension: "Suspension system supporting the rear wheels.",
  steering_type: "Mechanism used to control wheel direction.",
  front_brake_type: "Type of brake used on the front wheels.",
  rear_brake_type: "Type of brake used on the rear wheels.",
  minimum_turning_radius: "The smallest circle the vehicle can turn within.",
  wheel_size: "Diameter of the wheels fitted on the vehicle.",
  tyre_size: "Dimensions of the tyres for grip and stability.",
  tyre_type: "Type of tyre such as radial or tubeless.",

  length: "Total front-to-rear size of the vehicle.",
  width: "Side-to-side size of the vehicle.",
  height: "Overall vertical size from ground to roof.",
  wheel_base: "Distance between the front and rear wheels.",
  kerb_weight: "Weight of the vehicle without passengers or cargo.",
  gross_weight: "Maximum allowed weight including passengers and luggage.",
  seating_capacity: "Number of people the vehicle can seat.",
  boot_space: "Storage capacity for luggage.",
  no_of_doors: "Total number of passenger doors.",
  fuel_tank_capacity: "Maximum fuel the tank can hold.",

  power_steering: "Steering assist that makes turning easier.",
  power_windows_front: "Electrically operated front windows.",
  air_conditioner: "Cooling system for cabin temperature control.",
  automatic_climate_control: "System that maintains a set cabin temperature automatically.",
  multi_function_steering_wheel: "Steering wheel with audio, call, or control buttons.",
  engine_start_stop_button: "Push button used to start or stop the engine.",
  tachometer: "Displays the engine speed in revolutions per minute (RPM).",
  leather_seats: "Seats covered in leather material.",
  fabric_upholstery: "Seats covered in cloth material.",
  digital_cluster: "Fully digital instrument display.",

  alloy_wheels: "Lightweight metal wheels that improve looks and handling.",
  fog_lights_front: "Extra lights for better visibility in fog.",
  xenon_headlamps: "High-intensity discharge lights for brighter illumination.",
  adjustable_headlamps: "Headlights that are adjustable for better beam focus.",
  rain_sensing_wiper: "Wipers that activate automatically in rain.",
  rear_window_wiper: "Wiper for clearing the rear glass.",
  rear_window_washer: "Water spray for cleaning the rear window.",
  rear_window_defogger: "Heating system that removes fog from the rear glass.",
  wheel_covers: "Decorative covers fitted on steel wheels.",
  outside_rear_view_mirror_turn_indicators: "Turn signals integrated into side mirrors.",
  integrated_antenna: "Antenna built into the body for radio signals.",
  projector_headlamps: "Headlights that provide focused beam projection.",
  cornering_foglamps: "Fog lights that illuminate when turning.",
  roof_rails: "Bars on the roof for carrying luggage.",
  automatic_headlamps: "Lights that turn on automatically in low light.",
  antenna_shark_fin: "Small fin-shaped roof antenna.",
  sunroof: "Glass panel on the roof that opens for air and light.",
  panoramic_sunroof: "Large roof glass covering most of the cabin.",
  electronic_boot_opening: "Boot that opens using a button or remote.",
  orvm_powered_folding: "Side mirrors that fold electrically.",
  tyre_size_exterior: "Visible tyre dimension specification.",
  tyre_type_exterior: "Type of tyre such as radial or tubeless.",
  led_drls: "Lights that stay on during the day to improve visibility and styling.",
  led_headlamps: "Headlights powered by LED technology.",
  led_taillights: "Rear lights using LEDs.",

  anti_lock_braking_system_abs: "Prevents wheels from locking during braking.",
  driver_airbag: "Airbag that protects the driver in a crash.",
  passenger_airbag: "Airbag for front passenger protection.",
  no_of_airbags: "Total number of airbags in the vehicle.",
  central_locking: "Locks all doors simultaneously.",
  rear_camera: "Camera that assists while reversing.",
  child_safety_locks: "Prevents rear doors from opening from inside.",
  side_airbag: "Airbag that protects your chest and body in a side crash.",
  side_airbag_rear: "Side airbags for rear passengers.",
  curtain_airbag: "Airbag protecting head during side collisions.",
  electronic_brakeforce_distribution_ebd: "System that adjusts braking force across wheels.",
  seat_belt_warning: "Alert when seat belts are not fastened.",
  door_ajar_warning: "Alert if any door remains open.",
  tyre_pressure_monitoring_system_tpms: "Monitors tyre air pressure in real time.",
  day_night_rear_view_mirror: "Mirror that reduces glare from headlights behind.",

  radio: "Built-in system for listening to FM or AM stations.",
  wireless_phone_charging: "Charges compatible phones without cables.",
  bluetooth: "Wireless connection for calls and music.",
  wifi_connectivity: "Internet access through in-car Wi-Fi.",
  touchscreen: "Interactive display for infotainment controls.",
  touchscreen_size: "The size of the infotainment screen measured diagonally.",
  android_auto: "Allows Android phone apps on the car screen.",
  apple_carplay: "Connects iPhone apps to the car display.",
  no_of_speakers: "Total speakers in the audio system.",
  usb_ports: "Slots to charge devices or connect media.",
  tweeters: "Small speakers for high-frequency sound.",
  subwoofer: "Speaker designed for deep bass sound.",
  additional_features: "Extra features beyond the standard equipment.",
  jbl_cinematic_sound_system: "Premium JBL audio tuned for surround-like sound.",
  speakers_position: "Placement of speakers inside the cabin.",

  autonomous_emergency_braking: "Automatically brakes to avoid collisions.",
  lane_departure_warning: "Alerts if the vehicle drifts from its lane.",
  adaptive_cruise_control: "Maintains speed and distance from vehicles ahead.",
  connected_car: "Internet-enabled features like remote tracking and control.",
  over_the_air_updates: "Software updates downloaded wirelessly without visiting service."
};